export var activeStyle = '_1b2ln8w0';